import type { FC } from 'react';
import { Button, CardSelect, Text } from '@cencosud-cencommerce/paris-uikit';

interface Props {
  onAddAddress: VoidFunction;
  onEditAddress: VoidFunction;
  addressLabel?: string;
  hasAddresses: boolean;
}

const AddressCard: FC<Props> = ({
  onAddAddress,
  onEditAddress,
  addressLabel = '',
  hasAddresses
}) => {
  return (
    <CardSelect
      hideIconOnMobile
      className="co-border co-bg-white"
      ctaComponent={
        hasAddresses ? (
          <button onClick={onEditAddress} className="ui-focus-2">
            <Text color="primary-500" variant="link2" weight={600}>
              Modificar
            </Text>
          </button>
        ) : (
          <Button iconLeft="add" onClick={onAddAddress}>
            Agregar
          </Button>
        )
      }
      description1={addressLabel}
      iconName="place"
      title="Mi dirección"
    />
  );
};

export default AddressCard;
